import { render, staticRenderFns } from "./SlidoPoll.vue?vue&type=template&id=303a8f01"
import script from "./SlidoPoll.vue?vue&type=script&lang=js"
export * from "./SlidoPoll.vue?vue&type=script&lang=js"
import style0 from "./SlidoPoll.vue?vue&type=style&index=0&id=303a8f01&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports